export default {
  en: 'MMM dd, yyyy',
  fr: 'dd MMM, yyyy',
  es: 'dd MMM, yyyy',
};
